module.exports = __webpack_public_path__ + "static/media/txt.acafeac8.svg";